<script lang="ts">
	import { urlFragment } from '../../stores/url-fragment';
	import DarkenOverlay from './DarkenOverlay.svelte';
</script>

{#if $urlFragment.tab !== 'none'}
	<DarkenOverlay on:click={ () => urlFragment.setUrlKey( 'tab', 'none' ) } />
{/if}

<div class="trough">
	<slot />
</div>

<style>
	.trough {
		position: absolute;
		bottom: 0px;
		left: 0px;
		height: 50px;
		overflow: hidden;
	}
</style>
